import { ReactComponent as Reset } from "./svg/icon-reset.svg";

export const IconReset = () => <Reset />;
